import ManageDidController from './controller/ManageDidController.js'
import template  from './manageDid.component.tpl.pug'

const manageDid = {
  template: template(),
  controller: ManageDidController,
}

export default manageDid
